/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Responsibletenantusergroupid4Inputs */

const en_entity_responsibletenantusergroupid4 = /** @type {(inputs: Entity_Responsibletenantusergroupid4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsible Tenant User Group ID`)
};

const de_entity_responsibletenantusergroupid4 = /** @type {(inputs: Entity_Responsibletenantusergroupid4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verantwortliche Mandanten-Benutzergruppen-ID`)
};

/**
* | output |
* | --- |
* | "Responsible Tenant User Group ID" |
*
* @param {Entity_Responsibletenantusergroupid4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_responsibletenantusergroupid4 = /** @type {((inputs?: Entity_Responsibletenantusergroupid4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Responsibletenantusergroupid4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_responsibletenantusergroupid4(inputs)
	return de_entity_responsibletenantusergroupid4(inputs)
});
export { entity_responsibletenantusergroupid4 as "entity_responsibleTenantUserGroupId" }